import type { Metadata } from "next"

export const BASE_PATH = (process.env.NEXT_PUBLIC_BASE_PATH ?? "").replace(
  /\/$/,
  ""
)

export const HOST =
  process.env.NEXT_PUBLIC_HOST ?? "https://www.varsitytutors.com"

export const BASE_URL = `${HOST}${BASE_PATH}`

// Common API paths
export const API_BASE = `${BASE_PATH}/api`

// For reverse proxy deployments, all Netlify functions should be accessed through /api/
// This avoids the issue where reverse proxies don't forward /.netlify/functions/ requests
export const NETLIFY_FUNCTIONS_BASE = `${BASE_PATH}/api`

export const ALLOW_INDEXING = process.env.NEXT_PUBLIC_ALLOW_INDEXING === "true"

/** Configures robots meta tag for SEO based on NEXT_PUBLIC_ALLOW_INDEXING="true" */
export const robots: Metadata["robots"] = ALLOW_INDEXING
  ? {
      follow: true,
      googleBot: {
        follow: true,
        index: true,
        "max-image-preview": "large",
        "max-snippet": -1,
        "max-video-preview": -1
      },
      index: true
    }
  : {
      follow: false,
      index: false
    }
